<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/scniqO/tc-custom/9780544231948.jpg?1737441019991" alt="This image is the cover for the book Collection of Sand"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Collection of Sand
      </h1>
      <p class="bookDescription body article font2">
        <b>This “brilliant collection of essays” and travelogues by the celebrated author of <i>Invisible Cities</i> “may change the way you see the world around you” (<i>The Guardian</i>, UK).</b><br/>  <br/> Italo Calvino’s boundless curiosity and ingenious imagination are displayed in peak form in <i>Collection of Sand</i>, his last collection of new works published during his lifetime. Delving into the delights of the visual world—both in art and travel—the subjects of these 38 essays range from cuneiform and antique maps to Mexican temples and Japanese gardens. In Calvino’s words, this collection is “a diary of travels, of course, but also of feelings, states of mind, moods…The fascination of a collection lies just as much in what it reveals as in what it conceals of the secret urge that led to its creation” (from <i>Collection of Sand</i>).<br/>  <br/> Never before translated into English, <i>Collection of Sand</i> is an incisive and often surprising meditation on observation and knowledge, “beautifully translated by Martin McLaughlin” (<i>The Guardian</i>, UK).
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Italo Calvino
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?064504ba